import './MenuRow.css';

export function MenuRow({ children }: React.PropsWithChildren) {
    return <div className='menu-row'>{children}</div>;
}
